import { Box, styled } from '@mui/material';
import { GAUGE_CARD_SIZES } from '../constants';
import { StatisticSize } from '../types';

export const GaugeCardLabelWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StatisticSize }>(({ theme, size = 'md' }) => {
  const sizeConfig = GAUGE_CARD_SIZES[size] ?? GAUGE_CARD_SIZES.md;

  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: sizeConfig.labelFontSize,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  };
});
